module.exports = __webpack_public_path__ + "media/tubular adenoma.07f0d6c4.wav";